import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "../Styles/index.css";
import "./IntranetRedTheme.css";

import EncuestasUsuario from "./usuario/EncuestasUsuario";

export default function IntranetUsuarioEncuestasPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialItem = location.state?.initialItem;

  return (
    <div className="intranet-red-theme">
      <EncuestasUsuario
        onVolver={() => navigate("/menu/intranet/usuario")}
        initialEncuesta={initialItem}
      />
    </div>
  );
}
